import axios from '@/lib/axios';
import { FixedAsset, PaymentSchedule, Product, PurchaseOrderMember } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 0710. 支払予定削除
 * [DELETE] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/payment_schedules/:payment_schedule_id
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  payment_schedule_id: number;
};
const destroyPaymentSchedule = (props: Props): Promise<PaymentSchedule> => {
  return axios.delete(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/payment_schedules/${props.payment_schedule_id}`
  );
};

export const useDestroyPaymentSchedule = () => {
  return useMutation({
    mutationFn: destroyPaymentSchedule,
  });
};
